import { KpiDeltaDirection } from './kpi-tile.types';

export const kpiDeltaArrow: Record<KpiDeltaDirection, string> = {
  up: '▲',
  down: '▼',
  flat: '–',
};
